import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfAtestadoStyle.scss";
import moment from "moment/moment";
import "moment/locale/pt";

import Cabecalho from "../components/Cabecalho";
import Rodape from "../components/Rodape";

moment.locale("pt");

function PdfAtestado({ atestadoData, showPreviousPage }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Atestado-${atestadoData.cliente.nome}_${moment(
      new Date(),
    ).format("DD-MM-YYYY")}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  const fonteGeorgia = atestadoData.clinica?._id === "6817794da65ef747fc74730d";

  const cabecalhoRodape = atestadoData.clinica.cabecalhoRodape;
  const temCabecalhoBanner =
    cabecalhoRodape?.cabecalho && cabecalhoRodape?.atestado;
  const temRodapeBanner = cabecalhoRodape?.rodape && cabecalhoRodape?.atestado;
  const temCabecalhoERodapeBanner = temCabecalhoBanner && temRodapeBanner;

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-atestado-wrapper ${atestadoData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""}${fonteGeorgia ? " pdf-atestado--georgia" : ""}`}
      >
        <div
          className={`pdf-atestado-body ${
            temCabecalhoBanner
              ? "pdf-atestado-body__comCabecalhoRodape"
              : " pdf-atestado-body__semCabecalho"
          } ${
            temCabecalhoERodapeBanner
              ? "pdf-atestado-body__comCabecalhoERodape"
              : ""
          }`}
        >
          {/* TOP */}

          {temCabecalhoBanner ? (
            <div className="pdf-atestado-cabecalhoBanner__container">
              <Cabecalho linkImg={cabecalhoRodape?.cabecalho} />
            </div>
          ) : (
            <div className="pdf-atestado__cabecalho">
              <div className="pdf-atestado__cabecalho--left">
                <img
                  src={`${process.env.REACT_APP_BACKEND_LINK}/${atestadoData.clinica.logotipo}`}
                  alt=""
                />
              </div>
              <div className="pdf-atestado__cabecalho--right">
                <span className="pdf-atestado__cabecalho--right--dark">
                  {atestadoData.clinica.nome ? atestadoData.clinica.nome : ""}
                </span>
                <span className="pdf-atestado__cabecalho--right--dark">
                  {atestadoData.medico.name}/{atestadoData.medico.profissao}
                </span>
                <span>
                  Tel:
                  {atestadoData.clinica.contacto
                    ? atestadoData.clinica.contacto
                    : ""}
                  {atestadoData.clinica.contacto2
                    ? `/${atestadoData.clinica.contacto2}`
                    : ""}
                  {atestadoData.clinica.contacto3
                    ? `/${atestadoData.clinica.contacto3}`
                    : ""}
                </span>
                <span>{atestadoData.clinica.endereco}</span>
                <span className="pdf-atestado__cabecalho--right--dark">
                  NIF:{atestadoData.clinica.nif}
                </span>
              </div>
            </div>
          )}
          {/* CORPO */}
          <div className="pdf-atestado__corpo">
            {/* MIDDLE */}
            <div className="pdf-atestado__middle">
              <h2 className="pdf-atestado__middle__title">
                {atestadoData.tipo === "Dias e Comparecimento" ||
                atestadoData.tipo === "Dias"
                  ? "Atestado de Dias"
                  : "Atestado de Comparecimento"}
              </h2>

              <span>
                Atestamos para fins{" "}
                <span className="pdf-atestado--dark">
                  {atestadoData.finalidade}
                </span>
                , que{" "}
                <span className="pdf-atestado--dark">
                  {atestadoData.cliente.nome}
                </span>{" "}
                esteve presente nesta clínica para o tratamento odontológico:
              </span>

              {atestadoData.tipo_dependente === "Do próprio" && (
                <div className="pdf-atestado__middle__checkboxContainer">
                  <input
                    type="checkbox"
                    className="pdf-atestado__middle__checkboxContainer__checkbox"
                    defaultChecked={
                      atestadoData.tipo_dependente === "Do próprio"
                    }
                  />{" "}
                  <span className="pdf-atestado__middle__checkboxContainer__label">
                    Do próprio
                  </span>
                </div>
              )}
              {atestadoData.tipo_dependente === "Do seu dependente" && (
                <div className="pdf-atestado__middle__checkboxContainer">
                  <input
                    type="checkbox"
                    className="pdf-atestado__middle__checkboxContainer__checkbox"
                    defaultChecked={
                      atestadoData.tipo_dependente === "Do seu dependente"
                    }
                  />{" "}
                  <span className="pdf-atestado__middle__checkboxContainer__label">
                    Do seu responsável{" "}
                    <span className="pdf-atestado--dark">
                      {atestadoData.nome_dependente}
                    </span>
                  </span>
                </div>
              )}

              <span>
                No dia{" "}
                <span className="pdf-atestado--dark">
                  {moment(atestadoData.data_atestado).format("DD-MM-YYYY")}
                </span>
                ,
                {(atestadoData.tipo === "Comparecimento" ||
                  atestadoData.tipo === "Dias e Comparecimento") && (
                  <>
                    {" "}
                    no horário das{" "}
                    <span className="pdf-atestado--dark">
                      {moment(atestadoData.hora_inicial).format("HH:mm")}
                    </span>{" "}
                    às{" "}
                    <span className="pdf-atestado--dark">
                      {moment(atestadoData.hora_final).format("HH:mm")}
                    </span>
                  </>
                )}{" "}
                {(atestadoData.tipo === "Dias" ||
                  atestadoData.tipo === "Dias e Comparecimento") && (
                  <>
                    e deve ficar em repouso por{" "}
                    <span className="pdf-atestado--dark">
                      {atestadoData.dias * 24} horas
                    </span>
                    .
                  </>
                )}
              </span>

              <div className="pdf-atestado__middle__data-assinatura">
                <span className="pdf-atestado__middle__data-assinatura--data">
                  {atestadoData.clinica.ilha},{" "}
                  {moment().format("D [de] MMMM [de] YYYY")}
                </span>
                {atestadoData.medico?.assinatura?.ativa &&
                atestadoData.medico?.assinatura?.autorizacoes?.atestados &&
                atestadoData.medico?.assinatura?.imagem ? (
                  <img
                    src={`${process.env.REACT_APP_BACKEND_LINK}/${atestadoData.medico.assinatura.imagem}`}
                    alt="Assinatura"
                    className="assinatura-img"
                    style={{
                      maxHeight: "50px",
                      maxWidth: "150px",
                      objectFit: "contain",
                      display: "block",
                      margin: "4px 0",
                    }}
                  />
                ) : (
                  <span className="pdf-atestado__middle__data-assinatura--assinatura">
                    _____________________________________________________________
                  </span>
                )}
              </div>
              <span className="pdf-atestado__middle__data-assinatura--carimbo">
                (Assinatura e Carimbo)
              </span>
            </div>

            {/* RODAPÉ */}
            <div className="pdf-atestado__rodape">
              <span>
                Processado por{" "}
                <span className="pdf-atestado--dark"> HEALTH TECH CV</span>
              </span>
            </div>
          </div>

          {temRodapeBanner && (
            <div className="pdf-atestado-rodapeBanner__container">
              <Rodape linkImg={cabecalhoRodape?.rodape} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PdfAtestado;
